import { defineComponent, watch } from 'vue'
import {
  useChildren,
  useCustomFieldValue,
  useExpose,
  useNamespace,
} from '@xzx-design/hooks'
import { checkboxGroupEmits, checkboxGroupProps } from './checkbox-group'
import { CHECKBOX_GROUP_KEY } from './types'

import type {
  CheckboxGroupExpose,
  CheckboxGroupToggleAllOptions,
} from './types'

const name = 'XzxCheckboxGroup'

export default defineComponent({
  name,
  __name: name,
  props: checkboxGroupProps,
  emits: checkboxGroupEmits,
  setup(props, { emit, slots }) {
    const { b, m } = useNamespace('checkbox-group')

    const { children, linkChildren } = useChildren(CHECKBOX_GROUP_KEY)

    const updateValue = (value: unknown[]) => emit('update:modelValue', value)

    const toggleAll = (options: CheckboxGroupToggleAllOptions = {}) => {
      if (typeof options === 'boolean') {
        options = { checked: options }
      }

      const { checked, skipDisabled } = options

      const checkedChildren = children.filter((item: any) => {
        if (!item.props.bindGroup) {
          return false
        }
        if (item.props.disabled && skipDisabled) {
          return item.checked.value
        }
        return checked ?? !item.checked.value
      })

      const names = checkedChildren.map((item: any) => item.name)
      updateValue(names)
    }

    watch(
      () => props.modelValue,
      (value) => emit('change', value)
    )

    useExpose<CheckboxGroupExpose>({ toggleAll })
    useCustomFieldValue(() => props.modelValue)
    linkChildren({
      props,
      updateValue,
    })

    return () => (
      <div class={[b(), m(props.direction)]}>{slots.default?.()}</div>
    )
  },
})
